// A tiny localStorage-backed tracker for "recently visited" items (services,
// applications). Each kind holds a most-recent-first list of small records,
// de-duplicated by id and capped.

const KEY = 'toffs.recent';

function readStore() {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
}

function writeStore(store) {
  try {
    localStorage.setItem(KEY, JSON.stringify(store));
  } catch {
    /* ignore quota / unavailable storage */
  }
}

export function getRecent(kind) {
  return readStore()[kind] || [];
}

// recordVisit moves item to the front of its kind's list (deduped by id).
export function recordVisit(kind, item, cap = 10) {
  const store = readStore();
  const list = (store[kind] || []).filter((x) => x.id !== item.id);
  list.unshift(item);
  store[kind] = list.slice(0, cap);
  writeStore(store);
  return store[kind];
}
